// Master strip — master volume, a level meter, and the master FX amounts
// (reverb / delay / filter) for the shared FX bus (docs/07 §7.6).

export interface MixerStripHandlers {
  onMasterVolume(db: number): void;
  onReverb(amount: number): void;
  onDelay(amount: number): void;
  onFilter(hz: number): void;
}

export interface MixerStrip {
  element: HTMLElement;
  setMasterLevel(level: number): void;
}

export function createMixerStrip(handlers: MixerStripHandlers): MixerStrip {
  const el = document.createElement("div");
  el.className = "master";

  const label = document.createElement("div");
  label.className = "master__label";
  label.textContent = "Master";

  const meter = document.createElement("div");
  meter.className = "master__meter";
  const fill = document.createElement("div");
  fill.className = "master__meter-fill";
  meter.append(fill);

  const controls = document.createElement("div");
  controls.className = "master__controls";
  controls.append(
    slider("Volume", -40, 6, 1, 0, (v) => handlers.onMasterVolume(v)),
    slider("Reverb", 0, 1, 0.05, 0.6, (v) => handlers.onReverb(v)),
    slider("Delay", 0, 1, 0.05, 0.35, (v) => handlers.onDelay(v)),
    slider("Filter", 500, 16000, 100, 12000, (v) => handlers.onFilter(v)),
  );

  el.append(label, meter, controls);

  return {
    element: el,
    setMasterLevel(level) {
      fill.style.width = `${Math.max(0, Math.min(1, level)) * 100}%`;
    },
  };
}

function slider(
  label: string,
  min: number,
  max: number,
  step: number,
  value: number,
  onInput: (v: number) => void,
): HTMLElement {
  const wrap = document.createElement("label");
  wrap.className = "master__ctl";
  const tag = document.createElement("span");
  tag.className = "master__ctl-label";
  tag.textContent = label;
  const s = document.createElement("input");
  s.type = "range";
  s.min = String(min);
  s.max = String(max);
  s.step = String(step);
  s.value = String(value);
  s.className = "slider slider--mini";
  s.setAttribute("aria-label", `Master ${label}`);
  s.addEventListener("input", () => onInput(Number(s.value)));
  wrap.append(tag, s);
  return wrap;
}
